<template>
    <div class="q-pa-md" id="ReturnOrders">
        <q-dialog position="right" v-model="orderDetailDialog">
            <ReturnOrderDetail :order-id="orderId" @closeDialog="orderDetailDialog=false"></ReturnOrderDetail>
        </q-dialog>
        <div class="position-absolute" style="right: 15px; z-index: 1">
            <div class="d-flex">
                <q-input class="searchBox" debounce="300" placeholder="Search" style="width: 350px"
                         v-model="filter">
                    <template v-slot:prepend>
                        <q-icon name="search"/>
                    </template>
                </q-input>
            </div>
        </div>
        <div class="position-absolute" style="right: 370px; z-index: 1">
            <div class="d-flex">
                <div @click="returnOrderDialog=true" class="addButton d-flex">
                    <q-dialog persistent position="right" v-model="returnOrderDialog">
                        <ReturnOrderRequest :current-partner="currentPartner"
                                            @closeReturnOrderDialog="returnOrderDialog=false"></ReturnOrderRequest>
                    </q-dialog>
                    <div class="add-button-text mx-auto my-auto">Return Order</div>
                    <div class="add-button-icon mx-auto my-auto">
                        <i class="material-icons">add</i>
                    </div>
                </div>
            </div>
        </div>
        <q-tabs align="left" class="text-primary mt-3" style="padding-left: 16px; padding-right: 16px;"
                v-model="currentTab">
            <q-tab :class="tab.class" :key="index" :label="`${tab.label} (${tab.count})`" :name="tab.name"
                   v-for="(tab,index) in tabs"></q-tab>
        </q-tabs>
        <q-table :columns="$data[tabs[0].columnName]" :data="$data[tabs[0].dataName]" :filter="filter.trim()"
                 :pagination.sync="$data[tabs[0].pagination]"
                 :ref="tabs[0].dataName" :row-key="tabs[0].rowKey" class="table-header"
                 flat table-class="table-class" v-show="currentTab===tabs[0].name">
            <template v-slot:body="props">
                <q-tr :props="props" @click.native="openOrderDetail(props.row.id)" class="tableItems">
                    <q-td :props="props" class="tItem" key="orderNum">
                        {{props.row.orderNum?props.row.orderNum:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="FromOrganization">
                        {{props.row.FromOrganization?props.row.FromOrganization.name:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="ToOrganization">
                        {{props.row.ToOrganization?props.row.ToOrganization.name:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="status">
                        {{props.row.status?props.row.status:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="PlacedBy">
                        {{props.row.PlacedBy?props.row.PlacedBy.name:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="OrderItems_aggregate">
                        {{props.row.OrderItems_aggregate?props.row.OrderItems_aggregate.aggregate.count:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="createdOn">
                        {{props.row.createdOn?dateTimeFilter(props.row.createdOn):'-'}}
                    </q-td>
                </q-tr>
            </template>
        </q-table>
        <q-table :columns="$data[tabs[1].columnName]" :data="$data[tabs[1].dataName]" :filter="filter.trim()"
                 :pagination.sync="$data[tabs[1].pagination]"
                 :ref="tabs[1].dataName" :row-key="tabs[1].rowKey" class="table-header"
                 flat table-class="table-class" v-show="currentTab===tabs[1].name">
            <template v-slot:body="props">
                <q-tr :props="props" @click.native="openOrderDetail(props.row.id)" class="tableItems">
                    <q-td :props="props" class="tItem" key="orderNum">
                        {{props.row.orderNum?props.row.orderNum:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="FromOrganization">
                        {{props.row.FromOrganization?props.row.FromOrganization.name:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="ToOrganization">
                        {{props.row.ToOrganization?props.row.ToOrganization.name:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="status">
                        {{props.row.status?props.row.status:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="PlacedBy">
                        {{props.row.PlacedBy?props.row.PlacedBy.name:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="OrderItems_aggregate">
                        {{props.row.OrderItems_aggregate?props.row.OrderItems_aggregate.aggregate.count:'-'}}
                    </q-td>
                    <q-td :props="props" class="tItem" key="createdOn">
                        {{props.row.createdOn?dateTimeFilter(props.row.createdOn):'-'}}
                    </q-td>
                </q-tr>
            </template>
        </q-table>
    </div>
</template>

<script>
    import ReturnOrderRequest from '../ReturnOrder/ReturnOrderRequest'
    import {
        SUBSCRIBE_RETURN_ORDERS_FROM_ME,
        SUBSCRIBE_RETURN_ORDERS_TO_ME,
    } from '../../graphql/subscription/ReturnOrder'
    import ReturnOrderDetail from './ReturnOrderDetail'

    export default {
        name: 'ReturnOrders',
        components: {ReturnOrderDetail, ReturnOrderRequest},
        data() {
            let self = this
            return {
                currentPartner: JSON.parse(localStorage.getItem('user')),
                currentTab: 'Return To Me',
                tabs: [
                    {
                        name: 'Return To Me',
                        label: 'Return To Me',
                        class: 'text-deep-purple-6',
                        rowKey: 'name',
                        count: 0,
                        columnName: 'columnsToMe',
                        dataName: 'returnToMeOrders',
                        pagination: 'paginationToMe',
                    },
                    {
                        name: 'Return From Me',
                        label: 'Return From Me',
                        class: 'text-orange-7',
                        rowKey: 'name',
                        count: 0,
                        columnName: 'columnsFromMe',
                        dataName: 'returnFromMeOrders',
                        pagination: 'paginationFromMe',
                    },
                ],
                returnToMeOrders: [], returnFromMeOrders: [],
                paginationToMe: {rowsPerPage: 200},
                paginationFromMe: {rowsPerPage: 200},
                filter: '',
                columnsToMe: [
                    {
                        name: 'orderNum', label: 'Order Number',
                        field: row => row.orderNum ? row.orderNum : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'FromOrganization', label: 'From',
                        field: row => row.FromOrganization && row.FromOrganization.name ? row.FromOrganization.name : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'ToOrganization', label: 'To',
                        field: row => row.ToOrganization && row.ToOrganization.name ? row.ToOrganization.name : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'status', label: 'Status',
                        field: row => row.status ? row.status : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'PlacedBy', label: 'Requested By',
                        field: row => row.PlacedBy && row.PlacedBy.name ? row.PlacedBy.name : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'OrderItems_aggregate', label: 'Items',
                        field: row => row.OrderItems_aggregate && row.OrderItems_aggregate.aggregate.count
                            ? row.OrderItems_aggregate.aggregate.count : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'createdOn', label: 'Created On',
                        field: row => row.createdOn ? self.dateTimeFilter(row.createdOn) : '-',
                        align: 'left', sortable: true,
                    }],
                columnsFromMe: [
                    {
                        name: 'orderNum', label: 'Order Number',
                        field: row => row.orderNum ? row.orderNum : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'FromOrganization', label: 'From',
                        field: row => row.FromOrganization && row.FromOrganization.name ? row.FromOrganization.name : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'ToOrganization', label: 'To',
                        field: row => row.ToOrganization && row.ToOrganization.name ? row.ToOrganization.name : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'status', label: 'Status',
                        field: row => row.status ? row.status : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'PlacedBy', label: 'Requested By',
                        field: row => row.PlacedBy && row.PlacedBy.name ? row.PlacedBy.name : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'OrderItems_aggregate', label: 'Items',
                        field: row => row.OrderItems_aggregate && row.OrderItems_aggregate.aggregate.count
                            ? row.OrderItems_aggregate.aggregate.count : '-',
                        align: 'left', sortable: true,
                    }, {
                        name: 'createdOn', label: 'Created On',
                        field: row => row.createdOn ? self.dateTimeFilter(row.createdOn) : '-',
                        align: 'left', sortable: true,
                    }],
                returnOrderDialog: false,
                orderDetailDialog: false,
                orderId: null,
            }
        },
        apollo: {
            $subscribe: {
                returnFromMeOrders: {
                    query: SUBSCRIBE_RETURN_ORDERS_FROM_ME,
                    variables() {
                        return {partnerId: this.currentPartner.orgId}
                    },
                    result({data, loading}) {
                        if (!loading) {
                            console.log(data, this.currentPartner)
                            this.returnFromMeOrders = data.returnFromMeOrders
                            this.updateOrderCounts()
                        }
                    },
                }, returnToMeOrders: {
                    query: SUBSCRIBE_RETURN_ORDERS_TO_ME,
                    variables() {
                        return {partnerId: this.currentPartner.orgId}
                    },
                    result({data, loading}) {
                        if (!loading) {
                            this.returnToMeOrders = data.returnToMeOrders
                            this.updateOrderCounts()
                        }
                    },
                },
            },
        },
        methods: {
            openOrderDetail(orderId) {
                this.orderId = orderId
                this.orderDetailDialog = true
            },
            updateOrderCounts() {
                let self = this
                setTimeout(function () {
                    Object.values(self.tabs).forEach(tab => {
                        tab.count = self.$refs[tab.dataName].computedRowsNumber
                    })
                }, 100)
                self.$forceUpdate()
            },
        },
        mounted() {
            if (this.$route.query.orderId) {
                this.openOrderDetail(this.$route.query.orderId)
            }
        },
        watch: {
            'filter'() {
                this.updateOrderCounts()
            },
        },
    }
</script>

<style scoped>

</style>
